import md5 from 'md5';

// class DnDRotate {
//     constructor() {
//         this.temp = -1;
//         this.angleObj = { angle: 0 };
//     }

//     loop() {
//         this.drawRotated(this.angleObj.angle);
//         if (this.angleObj.angle === this.temp) {
//             TweenLite.ticker.removeEventListener("tick", this.loop.bind(this));
//         }
//         this.temp = this.angleObj.angle;
//     }

//     drawRotated(degrees) {
//         $(".animation_vongquay").css("transform", `rotate(${degrees}deg)`);
//     }

//     animateRotate(targetAngle) {
//         TweenMax.to(this.angleObj, 5, {
//             angle: targetAngle,
//             delay: 0,
//             repeat: 0
//         });

//         setTimeout(() => {
//             TweenLite.ticker.addEventListener("tick", this.loop.bind(this));
//         }, 0);
//     }
// }

// const AnimationLucky = (indexImg, countItems) => {
//     const rotateModule = new DnDRotate();
//     const ketQua = Math.floor(indexImg * (360 / countItems)) + 360 * 3;
//     rotateModule.animateRotate(ketQua);
// };

class MJPromotion {
    constructor(options) {
        this.settings = $.extend(this.defaultSettings(), options);
        this.cp = parseInt($(this.settings.el.cp).html());
        this.notEnoughCp = {
            en: 'You have run out of spins or do not have enough spins',
            vn: 'Bạn đã hết lượt hoặc không đủ lượt quay',
            id: 'Putaran tidak cukup',
            cn: '您已经用完次数或次数不足',
            th: 'คุณใช้รอบหมุนหมดหรือมีรอบหมุนไม่เพียงพอ',
        };
        this.Key128Bytesold = "";
        this.DataKey128 = "";
        this.init();
    }

    defaultSettings() {
        return {
            url: "",
            debug: {},
            directory: "",
            items: {},
            names: [],
            el: {
                cp: ".spoint",
                action: ".pm__rut",
                reward: "#popup_reward",
                inform: "#popup_inform",
                informContent: ".pm__inform-text",
                rewardContainer: "#rewardContainer",
            },
            variable: {
                spinable: true,
                urlGet: "",
                urlSave: "",
                methodGet: "",
                methodSave: ""
            },
            callback: function () {
                this.settings.callback();
            },
            animResult: function () { }
        };
    }

    closeAllPopup() {
        $(".popup").removeClass("active");
    }

    activePopup(id) {
        $(id).addClass("active");
    }

    informError(content) {
        $(this.settings.el.informContent).html(content);
        this.activePopup(this.settings.el.inform);
        $(this.settings.el.action).removeClass('MS__off');
    }

    nameToSrc(name) {
        return `${this.settings.directory}/${name}.${this.settings.items.type}`;
    }

    getAwardID(code) {
        return this.settings.items[code];
    }

    makePrize(response) {
        const Key128 = response.split("=");
        const _Data = Key128[1];
        this.DataKey128 += _Data;
        const index = parseInt(_Data.charAt(127));
        const wordNumber = prodTemplate.wordNumber || 1;
        const AC = _Data.substr(index + 32, wordNumber);
        const _Encry1 = _Data.substr(index, 32);
        const _Encry2 = md5(_Encry1 + _Data.substr(index + 32, wordNumber));
        const indexImg = this.getAwardID(AC);

        return {
            indexImg: indexImg,
            indexWord: AC,
            _Encry1: _Encry1,
            _Encry2: _Encry2,
            _Data: _Data,
            data: `Key32Bytes1=${_Encry1}&Key32Bytes2=${_Encry2}`
        };
    }

    handleData($this, responseData) {
        const listPrize = [];
        let data = [];
        const totalTurn = Number($this.data('value'));
        const type = totalTurn;

        if (totalTurn === 1) {
            const prize = this.makePrize(responseData);
            listPrize.push(prize);
            data = prize.data;
        } else {
            responseData.forEach(item => {
                const prize = this.makePrize(item);
                listPrize.push(prize);
                data = prize.data;
            });
        }

        if (type !== undefined) {
            $.ajax({
                type: this.settings.variable.methodSave,
                url: this.settings.variable.urlSave,
                dataType: "json",
                data: {
                    action: "save_data",
                    data: data,
                    type: type,
                    totalTurn: totalTurn,
                },
                success: (data) => {
                    this.processResponseData(data, listPrize, totalTurn);
                },
                error: (response) => {
                    this.settings.variable.spinable = true;
                    alert(response.data);
                },
            });
        } else {
            this.closeAllPopup();
            this.settings.variable.spinable = true;
            this.informError("Error: Missing data-type.");
        }

        this.Key128Bytesold = this.DataKey128;
        if (this.Key128Bytesold === this.DataKey128) {
            return false;
        }
    }

    processResponseData(data, listPrize, totalTurn) {
        if (data.status === 1 && data.data === "ok") {
            if (listPrize.length > 0) {
                $(this.settings.el.rewardContainer).empty();
                listPrize.forEach(prize => {
                    const indexName = prize.indexImg;
                    const imgUrl = this.nameToSrc(indexName);
                    const configNames = this.settings.names;
                    const template = `
                    <div class="item">
                        <img src="${imgUrl}"/>
                            ${configNames.en
                            ? `<div class="item-name">${configNames[$('body').attr('class')][prize.indexWord]}</div>`
                            : ''
                        }
                        </div>
                    `;
                    $(this.settings.el.rewardContainer).append(template);
                });

                if (typeof this.settings.animResult === "function") {
                    this.settings.animResult(listPrize);
                }

                setTimeout(() => {
                    if ($(".pm__usedPoint").length > 0) {
                        let usedPoint = parseInt($(".pm__usedPoint").html());
                        usedPoint += totalTurn;
                        $(".pm__usedPoint").html(usedPoint);
                    }

                    this.settings.callback();
                    $(this.settings.el.reward).removeClass('gift-1 gift-5 gift-10');
                    $(this.settings.el.reward).addClass('gift-' + listPrize.length);
                    this.activePopup(this.settings.el.reward);
                    $(this.settings.el.action).removeClass('MS__off');
                }, this.settings.config.timeWait);

                this.settings.variable.spinable = true;
            }
        }
    }

    getData($this) {
        const totalTurn = Number($this.data('value'));
        const type = totalTurn;
        const action = `get_data_${totalTurn}`;

        if (type !== undefined) {
            $.ajax({
                type: this.settings.variable.methodGet,
                url: this.settings.variable.urlGet,
                dataType: "json",
                data: { action, type, totalTurn, pool: currentPool },
                success: (response) => {
                    this.closeAllPopup();
                    this.settings.variable.spinable = true;

                    if (response.status === 1) {
                        this.handleData($this, response.data);
                    } else {
                        this.informError(response.data);
                    }
                },
                error: () => {
                    this.closeAllPopup();
                    this.settings.variable.spinable = true;
                    this.informError("Vui lòng kiểm tra lại kết nối mạng để tiếp tục");
                },
            });
        } else {
            this.closeAllPopup();
            this.settings.variable.spinable = true;
            this.informError("Error: Missing data-type.");
        }
    }

    main() {
        $(this.settings.el.action).on("click", (e) => {
            e.preventDefault();
            if (this.settings.variable.spinable) {
                this.closeAllPopup();
                this.settings.variable.spinable = false;

                const totalTurn = $(e.currentTarget).data('value');
                console.log('Total turn:', parseInt($(this.settings.el.cp).html()));
                if (parseInt($(this.settings.el.cp).html()) >= totalTurn) {
                    $(this.settings.el.action).addClass('MS__off');
                    this.getData($(e.currentTarget));
                } else {
                    this.settings.variable.spinable = true;

                    this.informError(prodTemplate.textNotEnough || this.notEnoughCp[$('body').attr('class')]);
                }
            }
        });
    }

    init() {
        if (this.settings.debug.status) {
            this.settings.variable.urlGet = `https://img.zing.vn/products/promotion/2023-platform-promotion/assets/playgame/getdata${this.settings.debug.action}.html`;
            this.settings.variable.urlSave = `https://img.zing.vn/products/promotion/2023-platform-promotion/assets/playgame/savedata.html`;
            this.settings.variable.methodGet = "GET";
            this.settings.variable.methodSave = "GET";
        } else {
            this.settings.variable.urlGet = this.settings.url;
            this.settings.variable.urlSave = this.settings.url;
            this.settings.variable.methodGet = "POST";
            this.settings.variable.methodSave = "POST";
        }

        this.main();
    }
}

export { MJPromotion };
